import { FormControlLabel, FormControlLabelProps } from '@mui/material'
import styled from 'styled-components'
import { Colors } from 'styles'

export const ControlLabelStyles = styled(
  FormControlLabel
)<FormControlLabelProps>`
  .MuiFormControlLabel-label {
    font-size: 1.2rem;
    margin-left: 0.8rem;
    color: ${Colors.blackAlt};
  }
`
